<template>
  <div class="AssetStatistics" ref="AssetStatistics">
    <div class="main_top">当前资产统计</div>
    <div class="main_title">
      <ul>
      </ul>
      <div class="main_title_right">
        <span class="wenzi">条件</span>
        <a-select v-model:value="conditions" @change="handleChange" style="width:120px;">
          <a-select-option value="">全部</a-select-option>
          <a-select-option value="1">用户ID</a-select-option>
          <a-select-option value="2">注册电话</a-select-option>
        </a-select>
        <a-input class="bgm" style="width:160px" placeholder="请输入搜索内容" v-model:value="RoomValue"/>
        <button @click="search({current:1,pageSize:paginationObj.pageSize})">查询</button>
      </div>
    </div>
    <a-table bordered :loading="tableloading" :columns="columns" :data-source="RoomData" :pagination="paginationObj"
             @change="search" :rowKey="(record,index)=>{return index}">
      <template #operate="{ record }">
        <button class="rechargess iconfont icon-chongzhitongji" @click="chong(record)"></button>
      </template>
    </a-table>
    <!-- 二次验证 -->
    <a-modal :getContainer="() => $refs.AssetStatistics" :closable="false" :footer="null" :centered="true"
             v-model:visible="visible" :mask="false" :destroyOnClose="true">
      <Authentication :urlcodeimg="urlcodeimg" @f5s="imgVerification" @sendInformation="sendInformation"
                      @validate="validate"></Authentication>
    </a-modal>
    <!-- 弹出框 -->
    <a-modal :getContainer="() => $refs.AssetStatistics" class="twoverification" :closable="false"
             v-model:visible="visible2" title="账户充值" @ok="handleOk" :mask="false" :destroyOnClose="true">
      <p class="chong">充值金额</p>
      <p class="chong" style="margin-bottom:30px">
        <a-input v-model:value="jine"/>
        元
      </p>
      <p class="chong">获得资产</p>
      <p class="chong" style="margin-bottom:0px">
        <a-input v-model:value="taibei" disabled/>
        泰贝
      </p>
    </a-modal>
  </div>
</template>
<script>
import {myMinxin} from "@/mixin"
import publics from '@/api/public'
import {
  queryAssetsStatistics,
  rechargeVerificationImageCode,
  rechargeVerificationPhoneCode,
  getRechargeVerificationCode,
  queryMoneyRate,
  rechargeAmountByAccountNO, updateLiveRoomRecoveryByAccountNO
} from "@/api/api"
import Authentication from "@/components/Authentication";
import {message, notification} from 'ant-design-vue';
import {methodCallback} from '@/api/methodCallback'

export default {
  name: "Person",
  mixins: [myMinxin],
  components: {
    Authentication
  },
  data() {
    return {
      conditions: '', //条件下拉框
      RoomValue: '', //筛选输入框
      RoomData: [],
      paginationObj: {
        hideOnSinglePage: true,
        pageSize: 10,
        pageIndex: 1,
        total: 0,
        size: "small",
      },
      columns: publics.columns1,
      tableloading: true,
      visible: false,
      visible2: false,
      jine: '',
      taibei: '',
      urlcodeimg: '', // 验证码图片地址
      codeid: '', // 验证码图片id
      rechargeVerificationUid: '', //身份认证标识
      rate: '', //利率
      accountid: '',
      currentSelectAccountAmount: 0,
    }
  },
  watch: {
    jine(newvale) {
      this.taibei = this.rate * newvale;
    }
  },
  mounted() {
    this.RechargeRecord({current: 1, pageSize: this.paginationObj.pageSize})
  },
  methods: {
    search(pagination) {
      this.paginationObj.pageIndex=pagination.current;
      this.RechargeRecord(pagination)
    },
    RechargeRecord(pagination) {
      let data = {
        pageIndex: pagination.current,
        PageSize: pagination.pageSize
      }
      if (this.conditions === '1') {
        if (this.RoomValue === "") {
          message.warn("请输入账号编号");
          return;
        }
        data = {...data, accountNO: this.RoomValue}
      }
      if (this.conditions === '2') {
        if (this.RoomValue === "") {
          message.warn("请输入手机号码");
          return;
        }
        data = {...data, phone: this.RoomValue}
      }
      queryAssetsStatistics(data)
          .then((res) => {
            if (res.data.code === "SUCCESS") {
              this.tableloading = false;
              this.RoomData = res.data.data.collections;
              this.paginationObj.total = res.data.data.total;
            } else if (res.data.code === "NOT_FOUND_DATA") {
              this.RoomData = [];
            } else {
              methodCallback(res);
            }
          })
          .catch((err) => {
            console.log(err)
          });
    },
    handleChange(value) {
      this.conditions = value
    },
    chong(record) {
      this.visible = true;
      this.imgVerification();
      this.accountid = record.accountNO;
      this.currentSelectAccountAmount = record.amount;
    },
    //图片验证码
    imgVerification() {
      let data = {
        width: 80,
        height: 30,
      }
      rechargeVerificationImageCode(data)
          .then((res) => {
            this.urlcodeimg = res.data.data.code
            this.codeid = res.data.data.uid
          })
          .catch((err) => {
            console.log(err)
          });
    },
    //发送短信接口
    sendInformation() {
      rechargeVerificationPhoneCode()
          .then((res) => {
            if (res.data.code === "SUCCESS") {
              notification.success({
                message: '提示！',
                description: "发送成功",
                duration: 2,
                key: "19",
                top: '20px',
              });
            } else {
              methodCallback(res);
            }
          })
          .catch((err) => {
            console.log(err)
          });
    },
    //充值身份验证
    validate(imageCode, phoneCode) {
      let data = {
        phoneCode: phoneCode,
        imageUid: this.codeid,
        imageCode: imageCode,
      }
      getRechargeVerificationCode(data)
          .then((res) => {
            console.log(res)
            if (res.data.code === "SUCCESS") {
              notification.success({
                message: '提示！',
                description: "验证通过",
                duration: 2,
                key: "20",
                top: '20px',
              });
              this.rechargeVerificationUid = res.data.data.rechargeVerificationUid;
              this.visible = false;
              this.visible2 = true;
              this.queryrates();
            } else {
              methodCallback(res);
            }
          })
          .catch((err) => {
            console.log(err)
          });
    },
    //查询利率
    queryrates() {
      queryMoneyRate()
          .then((res) => {
            if (res.data.code === "SUCCESS") {
              this.rate = res.data.data.rate
            } else {
              methodCallback(res);
            }
          })
          .catch((err) => {
            console.log(err)
          });
    },
    handleOk() {
      let data = {
        accountNO: this.accountid,
        rechargeVerificationUid: this.rechargeVerificationUid,
        amount: this.jine
      }
      let tempCurrentSelectAccountAmount=Number.parseFloat(this.currentSelectAccountAmount);
      rechargeAmountByAccountNO(data)
          .then((res) => {
            console.log(res)
            if (res.data.code === "SUCCESS") {
              notification.success({
                message: '提示！',
                description: "充值成功",
                duration: 2,
                key: "21",
                top: '20px',
              });
               if (tempCurrentSelectAccountAmount < 0
                  && (tempCurrentSelectAccountAmount + parseFloat(data.amount) > 0)) {
                updateLiveRoomRecoveryByAccountNO({accountNO: data.accountNO}).then(updateData => {
                  if (updateData.data.code !== "SUCCESS") {
                    notification.warn({
                      message: '提示！',
                      description: "充值成功,恢复欠费直播间失败",
                      duration: 2,
                      key: "21",
                      top: '20px',
                    });
                  }
                }).catch(error => {
                  console.error(error)
                });
               }
               this.search({
                 current: this.paginationObj.pageIndex,
                 pageSize:  this.paginationObj.pageSize
               })
              this.visible2 = false;
            } else {
              notification.error({
                message: '警告！',
                description: "充值失败",
                duration: 2,
                key: "22",
                top: '20px',
              });
            }
          })
          .catch((err) => {
            console.log(err)
          });
    },

  }
}
</script>
<style lang="less" scoped>
// /deep/ .ant-spin-nested-loading > div > .ant-spin{
//   background: #242526;
// }
.AssetStatistics {
  background: #242526;
  height: 100%;
  border-radius: 4px;

  .main_top {
    width: 100%;
    height: 48px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 48px;
    text-indent: 30px;
    border-bottom: 1px solid #3f3f3f;
  }

  .main_title {
    display: flex;
    justify-content: space-between;
    padding: 20px 30px 0 30px;

    /deep/ .ant-select-arrow {
      color: rgba(255, 255, 255, 0.6) !important;
    }

    .main_title_right {
      .wenzi {
        font-size: 14px;
        color: #FFFFFF;
        margin-right: 15px;
      }

      /deep/ .ant-select-selector {
        background: #181818 !important;
        border: 1px solid #3f3f3f !important;
        border-radius: 2px !important;
        color: rgba(255, 255, 255, 0.6);
      }

      .bgm {
        background: #181818 !important;
        border: 1px solid #3F3F3F !important;
        border-radius: 2px !important;
        color: rgba(255, 255, 255, .6);
        margin: 0 20px;
      }

      button {
        width: 80px;
        height: 30px;
        background: #1877f2;
        border: none;
        border-radius: 2px;
        cursor: pointer;
        color: #FFF;
      }
    }

    ul {
      display: flex;

      li {
        margin-right: 30px;
        color: #ffffff;

        span {
          margin-right: 20px;
          font-size: 14px;
        }

        /deep/ .ant-input {
          width: 120px;
          height: 30px;
          border: 1px solid #626262;
          background: #181818;
          color: #ffffff;
          font-size: 14px;
        }
      }
    }
  }

  /deep/ .ant-table-placeholder {
    background: #181818;
    border: 1px solid #242526;
    box-sizing: border-box;
  }

  /deep/ .ant-table {
    background: #242526;
  }

  /deep/ .ant-table-wrapper {
    box-sizing: border-box;
    padding: 20px 30px;

    .ant-table-content {
      border-radius: 6px;
      overflow: hidden;
    }

    .ant-table-bordered .ant-table-thead > tr > th,
    .ant-table-bordered .ant-table-tbody > tr > td {
      border-right: 1px solid #242526;
    }

    .ant-table-thead > tr > th {
      border-bottom: 1px solid #242526;
    }

    .ant-table-bordered .ant-table-header > table,
    .ant-table-bordered .ant-table-body > table,
    .ant-table-bordered .ant-table-fixed-left table,
    .ant-table-bordered .ant-table-fixed-right table {
      border: 1px solid #242526;
      border-right: 0;
      border-bottom: 0;
    }

    .ant-table-body {
      .rechargess {
        width: 20px;
        height: 20px;
        padding: 0;
        background: none;
        color: #FFFFFF;
        border: none;
        font-size: 20px;
        line-height: 20px;
        cursor: pointer;
      }

      table {
        background: #181818;

        .ant-table-align-center {
          background: rgba(10, 10, 10, .8);
          color: #fff;
          padding: 3px;
          font-size: 14px;
        }

        .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
          background: #181818 !important;
        }

        .ant-table-row {
          color: #fff;

          td {
            padding: 8px;
            background: #181818;
            border-bottom: 1px solid #242526;

            .ant-input-affix-wrapper {
              .ant-input {
                background: #181818 !important;
                color: #FFF;
                text-align: center;
                border: none;
              }
            }
          }
        }
      }
    }
  }

  /deep/ .ant-modal.twoverification {
    width: 260px !important;

    .ant-modal-body {
      padding: 30px 0 30px 30px;
    }
  }

  /deep/ .ant-modal {
    width: auto !important;
    // height: 320px;
    padding-bottom: 0;

    .ant-modal-header {
      background: #131313;
      padding: 15px 30px;
      height: 50px;
      border-bottom: 1px solid #414141;
      box-sizing: border-box;

      .ant-modal-title {
        font-size: 18px;
        line-height: 20px;
        color: #FFF;
      }
    }

    .ant-modal-body {
      background: #131313;
      padding: 0;

      .chong {
        font-size: 16px;
        line-height: 18px;
        color: #FFFFFF;
        margin-bottom: 10px;

        input {
          width: 160px;
          height: 32px;
          line-height: 32px;
          color: #FFF;
          background: #242525;
          border: none;
          margin-right: 10px;
        }
      }
    }

    .ant-modal-footer {
      background: #131313;
      border-top: none;
      padding: 0 30px 28px 30px;

      div {
        display: flex;
        justify-content: space-between;
      }

      .ant-btn {
        width: 90px;
        height: 30px;
        border-radius: 4px;
        background: #242525;
        border: none;
        color: #FFF;
        font-size: 14px;
      }

      .ant-btn-primary {
        background: #1876EF;
      }
    }
  }

  /deep/ .ant-pagination-item a, /deep/ .ant-pagination-next a, /deep/ .ant-pagination-next, /deep/ .ant-pagination-prev a {
    color: #FFF;
  }

  /deep/ .ant-pagination-item-active {
    background: none;
  }
}
</style>
